<template>

    <v-app>
        <v-toolbar flat color="white">
            <v-toolbar-title class="congatec-gray">User administration</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-text-field id="user_search_bar"
                          v-model="search"
                          class="searchbar"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details></v-text-field>

            <v-btn id="create_user_button" class="text-none" v-if="createUser" color="success"
                   @click.stop="onCreateUser"><span
                    class="text-xs-left">Create user</span>
            </v-btn>
            <ShowUserModal v-model="showUserModal" :editMode="editMode" :createUser="createMode"
                           :user="user"/>
            <ConfirmUserDeletionModal v-model="showDeletionModal" :user="user"/>

            <AssignRoleToUserModal v-model="showUserRoleAssignmentModal" :editMode="editMode"
                                   :userRoles="selectedUserRoles" :user="user"/>
        </v-toolbar>


        <v-divider></v-divider>


        <v-toolbar flat color="white" v-if="error">
            <v-spacer></v-spacer>

            <v-alert :value="error" type="error" transition="scale-transition">
                {{ errorMessage }}

                <v-btn small flat icon color="white" @click="closeAlert">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>

            </v-alert>

        </v-toolbar>


        <v-card flat>
            <v-data-table :headers="headers"
                          :items="users"
                          :expand="expand"
                          item-key="userName"
                          :search="search"
                          :sortable="true"
                          :rows-per-page-items="rowsPerPage">
                <template slot="header-cell">
                    <tr>
                        <td>test</td>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr @click="props.expanded = !props.expanded">
                        <td class="text-xs-left width-username">{{ props.item.userName }}</td>
                        <td class="text-xs-left width-firstName">{{ props.item.firstName }}</td>
                        <td class="text-xs-left width-lastName">{{ props.item.lastName }}</td>
                        <td v-if="props.item.isActive" class="text-xs-left width-isActive">
                            <v-icon color="green" small>fas fa-circle</v-icon>
                        </td>
                        <td class="text-xs-left" v-else>
                            <v-icon color="red" small>fas fa-circle</v-icon>
                        </td>
                        <td class="text-xs-left width-options">
                            <v-btn :id="'edit_user_button_' + props.index" color="green" dark small
                                   @click.native.stop="onEditUser(props.item)">
                                <v-icon v-if="updateUser" class="mr-2">edit</v-icon>
                                <v-icon v-else class="mr-2">far fa-eye</v-icon>
                            </v-btn>

                            <v-btn :id="'assign_user_button_' + props.index" dark small
                                   @click.native.stop="onAssignRoleToUser(props.item)">
                                <v-icon class="mr-2">fa-link</v-icon>
                            </v-btn>

                            <v-btn :id="'delete_user_button_' + props.index" color="red" dark small
                                   @click.native.stop="onDeleteUser(props.item)"
                                   v-if="deleteUser">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>

                <template slot="expand" slot-scope="props" style="background-color: #DCDCDC">
                    <v-data-table hide-actions hide-headers :items="getSelectedRoles(props.item)" :sortable="false"
                                  :headers="expandHeaders">
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td class="text-sm-left width-username"
                                    style="background-color: #DCDCDC; font-weight: bold;" v-if="props.index === 0">
                                    Roles assigned to user:
                                </td>
                                <td v-else class="width-username"
                                    style="background-color: #DCDCDC;"></td>

                                <td class="width-firstName text-xs-left"
                                    style="background-color: #DCDCDC; font-weight: bold;">{{ props.item
                                    }}
                                </td>
                                <td class="width-lastName"/>
                                <td class="width-isActive"/>
                                <td class="width-options"/>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <tr>
                                <td class="text-xs-left"
                                    style="width: 37.5%; background-color: #DCDCDC; font-weight: bold;">No role assigned
                                    to user.
                                </td>
                                <td class="text-xs-center" style="width: 70%;"></td>
                            </tr>

                        </template>
                    </v-data-table>
                </template>


            </v-data-table>
        </v-card>
    </v-app>

</template>


<script>

    import ShowUserModal from './modals/ShowUserModal.vue'
    import ConfirmUserDeletionModal from './modals/ConfirmUserDeletionModal'
    import userinterface from "../../../interfaces/userinterface";
    import {EventBus} from "../../../eventbus";
    import AssignRoleToUserModal from "./modals/AssignRoleToUserModal"
    import userrolemanager from "../../../managers/userrolemanager";

    export default {
        name: "UserList",

        components: {
            ShowUserModal,
            ConfirmUserDeletionModal,
            AssignRoleToUserModal
        },

        data: () => ({
            expand: false,

            search: '',

            rowsPerPage: [25, 50, 100, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

            headers: [
                {text: 'Username', value: 'userName'},
                {text: 'Firstname', value: 'firstName'},
                {text: 'Lastname', value: 'lastName'},
                {text: 'Is active', value: 'isActive'},
                {text: 'Options', value: 'options'}
            ],

            expandHeaders: [
                {text: 'Assigned roles to user:', value: 'userName'},
                {text: 'Role name', value: 'name'}
            ],

            user: {
                userId: null,
                userName: null,
                firstName: null,
                lastName: null,
                password: null,
                email: null,
                isActive: false
            },

            emptyUser: {
                userId: null,
                userName: null,
                firstName: null,
                lastName: null,
                password: null,
                email: null,
                isActive: false
            },

            users: [],

            createUser: false,
            deleteUser: false,
            updateUser: false,

            error: false,
            errorMessage: null,

            showUserModal: false,
            editMode: false,
            createMode: false,
            showDeletionModal: false,
            showUserRoleAssignmentModal: false,

            selectedUserRoles: []
        }),

        mounted() {
            EventBus.$on('userModalClosed', () => {
                this.initialize();
                this.user = Object.assign({}, this.emptyUser);
                this.showUserModal = false;
            });
            EventBus.$on('userDeletionConfirmed', () => {
                this.initialize();
                this.user = Object.assign({}, this.emptyUser);
                this.showDeletionModal = false;
            });
            EventBus.$on('userDeletionClosed', () => {
                this.initialize();
                this.user = Object.assign({}, this.emptyUser);
                this.showDeletionModal = false;
            });
            EventBus.$on('userRoleAssignmentModalClosed', () => {
                this.initialize();
                this.user = Object.assign({}, this.emptyUser);
                this.showUserRoleAssignmentModal = false;
                this.selectedUserRoles = [];
            });
        },

        created() {
            this.initialize();
            this.initializeRights();
        },

        methods: {

            onCreateUser() {
                this.user = Object.assign({}, this.emptyUser);
                this.editMode = true;
                this.createMode = true;

                this.showUserModal = true;
            },

            onEditUser(user) {
                let clonedUser = {
                    userId: user.userId,
                    userName: user.userName,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    password: null,
                    passwordRepeat: null,
                    email: user.email,
                    isActive: user.isActive,
                    selectedRoles: []
                };

                this.user = Object.assign({}, clonedUser);
                this.editMode = this.updateUser;
                this.createMode = false;

                this.showUserModal = true;
            },

            async onDeleteUser(user) {
                this.user = Object.assign({}, user);
                this.showDeletionModal = true;
            },

            async onAssignRoleToUser(user) {
                let clonedUser = {
                    userId: user.userId,
                    userName: user.userName,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    password: null,
                    passwordRepeat: null,
                    email: user.email,
                    isActive: user.isActive,
                    selectedRoles: []
                };

                this.user = Object.assign({}, clonedUser);
                this.editMode = this.updateUser;

                await userrolemanager.getUserRoles(user, userRoles => {
                    this.selectedUserRoles = userRoles;
                });

                this.showUserRoleAssignmentModal = true;
            },

            initialize() {
                userinterface.getUsers(users => {
                    this.users = users;
                })
            },

            initializeRights() {

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "UserCreate") {
                        this.createUser = true
                    }

                    if (right.right === "UserDelete") {
                        this.deleteUser = true
                    }

                    if (right.right === "UserUpdate") {
                        this.updateUser = true
                    }
                });
            },

            getSelectedRoles(user) {
                let roles = [];

                if (user.userRoles != null) {
                    user.userRoles.forEach(userRole => {
                        if (userRole.role != null && userRole.role.name != null) {
                            roles.push(userRole.role.name);
                        }
                    })
                }

                return roles;
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    };


</script>

<style>
    .width-username {
        width: 15%;
    }

    .width-lastName {
        width: 15%;
    }

    .width-firstName {
        width: 15%;
    }

    .width-isActive {
        width: 10%;
    }

    .width-options {
        width: 25%;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/users/UserList.vue